import { useIntl } from 'react-intl';

import styles from './EventsConfiguration.module.scss';

import CategoryTags from 'Screens/Dashboard/EventsConfiguration/CategoryTags/CategoryTags';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';
import EmptyState from 'Components/Common/EmptyState/EmptyState';
import sharedMessages from 'Components/utils/sharedMessages';
import EventRoleTags from './EventRoleTags/EventRoleTags';
import EventsConfigurationInfoCard from './EventsConfigurationInfoCard/EventsConfigurationInfoCard';
import useGetUser from 'hooks/useGetUser';
import NotConfiguredEmptyState from 'Components/Common/NotConfiguredEmptyState/NotConfiguredEmptyState';

const EventsConfiguration = () => (
    <div className={styles.container}>
        <div className={styles.innerContainer}>
            <CategoryTags />
            <EventRoleTags />
        </div>
        <EventsConfigurationInfoCard className={styles.infoCard} />
    </div>
);

const EventsStateHandler = () => {
    const currentEntityId = useGetCurrentEntityId();
    const intl = useIntl();

    const user = useGetUser();
    
    if (user && !user.hasInitialSetupCompleted) {
        return (
            <NotConfiguredEmptyState />
        );
    }

    if (!currentEntityId) {
        return <EmptyState title={intl.formatMessage(sharedMessages.noEntitySelected)} />;
    }

    return <EventsConfiguration />;
};

export default EventsStateHandler;
